import { render, staticRenderFns } from "./PlanSummary.vue?vue&type=template&id=27ed7cb4"
import script from "./PlanSummary.vue?vue&type=script&lang=js"
export * from "./PlanSummary.vue?vue&type=script&lang=js"
import style0 from "./PlanSummary.vue?vue&type=style&index=0&id=27ed7cb4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ed7cb4')) {
      api.createRecord('27ed7cb4', component.options)
    } else {
      api.reload('27ed7cb4', component.options)
    }
    module.hot.accept("./PlanSummary.vue?vue&type=template&id=27ed7cb4", function () {
      api.rerender('27ed7cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/membership/PlanSummary.vue"
export default component.exports